import React from "react";

export default function ChapterLinkCard({ href, label, thumbSrc, thumbAlt }) {
    return (
        <div>
            <p className="text-sm font-semibold text-gray-600 mb-2">Skip to chapter</p>
            <a href={href} className="group block max-w-sm">
                <div className="flex gap-4 items-center">
                    {thumbSrc ? (
                        <img
                            src={thumbSrc}
                            alt={thumbAlt || label}
                            className="w-fit h-24 object-cover rounded-md shadow"
                        />
                    ) : (
                        <div className="w-24 h-24 rounded-md bg-gray-200 shadow" />
                    )}
                    <span className="text-blue-700 font-bold text-lg group-hover:underline">
                        {label}
                    </span>
                </div>
            </a>
        </div>
    );
}
